import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { useScreen } from '../../../../hooks'
import { FormFieldSelectNG } from '../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../Formik'
import { EmailAccountSelect } from '../../EmailAccountSelect'
import { EmailFormContext } from '../../EmailForm.context'

import { getEmailAccountSelectFieldError } from './EmailAccountSelectField.utils'

import * as styles from './EmailAccountSelectField.module.css'

function EmailAccountSelectField({
  apiParams,
  blocked,
  fieldComponentProps,
  isLoading,
  label,
  name,
  placeholder,
  ...restProps
}) {
  const { t } = useTranslation()
  const { setFieldError, values } = useFormikContext()
  const { blocked: formBlocked } = useContext(EmailFormContext)

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  function handleCloseSelect() {
    const selectedValue = values[name]

    const error = getEmailAccountSelectFieldError({
      selectedValue,
      t,
    })

    setFieldError(name, error)
  }

  return (
    <FormikField
      {...restProps}
      withEntityCreationFromSearchValue
      Component={FormFieldSelectNG}
      Select={EmailAccountSelect}
      apiParams={apiParams}
      blocked={blocked || formBlocked}
      controlProps={{
        blocked: blocked || formBlocked,
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: { placeholder },
        },
      }}
      fieldComponentProps={{
        ...fieldComponentProps,
        isLoading,
        label,
        labelClassName: styles.fieldLabel,
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      name={name}
      onCloseDropdown={handleCloseSelect}
    />
  )
}

export default EmailAccountSelectField
